import { render } from "./bulk-customers-upload.vue?vue&type=template&id=d9e05d32&scoped=true"
import script from "./bulk-customers-upload.vue?vue&type=script&lang=js"
export * from "./bulk-customers-upload.vue?vue&type=script&lang=js"

import "./bulk-customers-upload.vue?vue&type=style&index=0&id=d9e05d32&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9e05d32"]])

export default __exports__